import { Typography } from "@mui/material";
import { useTranslate } from "@/hooks";
import { IBreakOrEndProps } from "./BreakOrEnd.props";
import { CustomSelect } from "@/ui";
import { useEffect, useState } from "react";
import { IActionBreak } from "@/types/ses/sesItemConfigTypes";

const BreakOrEnd = ({ selectExtendedAction, idx, channel, action, handleSaveActionInStore }: IBreakOrEndProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	const [gotoValue, setGotoValue] = useState<"no" | "start">(action.action === "break" && action.goto ? action.goto : "no");
	const variantsList = [
		{ value: "no", title: "title_no" },
		{ value: "start", title: "title_onStart" },
	];

	const handleChangeGotoValue = (value: string) => {
		if (value === "no" || value === "start") {
			setGotoValue(value);
		}
	};

	useEffect(() => {
		if (action.action === "break") {
			const data: { channel: string; idx: number; action: Partial<IActionBreak> } = { channel, idx, action: { goto: gotoValue } };
			handleSaveActionInStore(data);
		}
	}, [gotoValue]);

	return selectExtendedAction === "break" ? (
		<CustomSelect
			variantsList={variantsList}
			value={gotoValue}
			title={translate("title_goTo")}
			setState={handleChangeGotoValue}
			elementWidth={"full"}
			valueIndex={0}
			height={33}
			mt="0"
		/>
	) : (
		<Typography sx={{ fontSize: 11, m: "auto 0", width: "100%", textAlign: "left", fontStyle: "italic", whiteSpace: "pre-line", maxWidth: "500px", lineHeight: 1.2 }}>
			{translate(/*selectExtendedAction === "break" ? "title_actionBreak" :*/ "title_actionEnd")}
		</Typography>
	);
};

export default BreakOrEnd;
